import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUserCountryCode } from 'helper/user';
import { fetchShopifyShopsAction } from 'actions/shopify-actions';

const DEFAULT_SHOP_CONTEXT = {
  shop: null,
  userInfo: null,
  refetchShops: () => undefined,
};

export const ShopContext = React.createContext(DEFAULT_SHOP_CONTEXT);

const ShopContextProvider = ({ children, dispatch, shop, userInfo }) => {
  const refetchShops = () => {
    dispatch(
      fetchShopifyShopsAction({
        countryCode: getUserCountryCode(userInfo),
      }),
    );
  };

  const ctxValue = React.useMemo(
    () => ({
      shop,
      userInfo,
      refetchShops,
    }),
    [shop, userInfo, refetchShops],
  );

  return (
    <ShopContext.Provider value={ctxValue}>{children}</ShopContext.Provider>
  );
};

ShopContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
  dispatch: PropTypes.func.isRequired,
  shop: PropTypes.shape({}),
  userInfo: PropTypes.shape({}).isRequired,
};

ShopContextProvider.defaultProps = {
  shop: null,
};

export default connect(null)(ShopContextProvider);
